module.exports = __webpack_public_path__ + "static/media/categorization.66c165fe.svg";